import {
    Instance,
    Knot,
    Promize,
    Table,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from '@services/assetService';
import { AuthService } from '@services/authService';
import { LanguageService } from '@services/languageService';
import { LicenseService } from '@services/licenseService';
import { MembershipService } from '@services/membershipService';
import { OrganizationService } from '@services/organizationService';
import { UtilService } from '@services/utilService';
import { initTable } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class MembershipsIndexController extends DashboardController {
    static readonly inject = [
        'instances',
        'authService',
        'membershipService',
        'licenseService',
        'organizationService',
        'utilService',
        'languageService',
        'assetService',
    ] as const;

    userId!: string;
    membershipsTable!: Table;
    licensesTable!: Table;
    btnOrdersNew!: Knot;

    constructor(
        instances: Instance,
        private authService: AuthService,
        private membershipService: MembershipService,
        private licenseService: LicenseService,
        private organizationService: OrganizationService,
        private utilService: UtilService,
        private languageService: LanguageService,
        private assetService: AssetService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this.userId = this.state.getParam('userId');

        this._initToolbarButtons();
        this._initTabPanel('memberships');
        this._changeToolbarButtons();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._changeToolbarButtons();

        this._initMembershipsTable();
        this._initLicensesTable();
        return true;
    }

    private _changeToolbarButtons(): void {
        this.utilService.showButton(
            this.btnOrdersNew,
            this.activeTab === 'licenses',
        );
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-users-home', this.dom, () => {
            this.state.goBack('users.home');
        });

        this.btnOrdersNew = this.helper.fabButton(
            '.btn-orders-new',
            this.dom,
            () => {
                this.state.go('orders.new');
            },
        );
    }

    private _initMembershipsTable(): void {
        this.membershipsTable = initTable(
            this.membershipsTable,
            this.dom,
            '.memberships-table',
            this.membershipService,
            {
                entityKey: 'memberships',
                fetchData: (params) =>
                    this.membershipService.getAll(params),
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (membership) => {
                        this.membershipService
                            .editDialog(membership)
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
            'memberships',
            this.activeTab,
        )!;
    }

    private _initLicensesTable(): void {
        this.licensesTable = initTable(
            this.licensesTable,
            this.dom,
            '.licenses-table',
            this.licenseService,
            {
                entityKey: 'licenses',
                fetchData: (params) =>
                    this.licenseService.getAllByUser(this.userId, params),
            },
            undefined,
            'licenses',
            this.activeTab,
        )!;
    }
}

export const membershipsIndexController = app.controller(
    'membershipsIndexController',
    MembershipsIndexController,
);
